import "./Education.css";

export default function EducationScreen({ academic }) {
  // support: academic can be a string OR an array of objects
  const isList = Array.isArray(academic);

  return (
    <section className="section" id="education" aria-label="Education">
      <div className="sectionHeader">
        <div className="sectionNum">02.</div>
        <h2 className="sectionTitle">Education</h2>
      </div>

      {isList ? (
        <div className="eduList">
          {academic.map((it, i) => (
            <article className="eduItem" key={`${it.title || "edu"}-${i}`}>
              <div className="eduTop">
                <div className="eduTitle">{it.title}</div>
                {it.range ? <div className="eduRange">{it.range}</div> : null}
              </div>

              <div className="eduMeta">
                {it.school ? <span className="eduSchool">{it.school}</span> : null}
                {it.stream ? <span className="eduDot">•</span> : null}
                {it.stream ? <span className="eduStream">{it.stream}</span> : null}
              </div>
            </article>
          ))}
        </div>
      ) : (
        <p className="muted prewrap aboutText">{academic || ""}</p>
      )}
    </section>
  );
}
